import { db } from "app/firebaseInit";
import {
    collection,
    query,
    where,
    orderBy,
    limit,
    getDocs,
    startAfter,
} from "firebase/firestore";

const colRef = collection(db, "systemLogs");

export const systemLogsService = {
    async fetchLogs({
        level,
        lastDoc,
        pageSize = 25,
    }) {
        let q = query(
            colRef,
            orderBy("createdAt", "desc"),
            limit(pageSize)
        );

        // Level filter
        if (level) {
            q = query(q, where("level", "==", level));
        }

        // Pagination
        if (lastDoc) {
            q = query(q, startAfter(lastDoc));
        }

        const snapshot = await getDocs(q);

        return {
            items: snapshot.docs.map((d) => ({
                id: d.id,
                ...d.data(),
            })),
            lastDoc: snapshot.docs[snapshot.docs.length - 1] || null,
        };
    }
};
